var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-container"},[_c('div',{ref:"dplayer",staticClass:"player",attrs:{"id":"dplayer"}}),(_vm.player.status > 0)?_c('div',{class:['status', 'status-' + _vm.player.status]}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }